import { useMemo }             from 'react';
import { connect }             from 'react-redux';
import { reducerType }         from 'reducer';
import { words }               from 'utils/dictionary';
import {
  modalStateType,
  userInfoType,
  userInfoKeyType
 }                             from 'types';


import useExpirationText       from './useExpirationText';
import useModalTitle           from './useModalTitle';
import { componentsStateType } from 'reducer/types';
import { makeStyles }           from 'makeStyles';
//import WhatsappLink from 'components/WhatsappLink';



const useStyles = makeStyles()(() => ({
    title: {
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        paddingTop:      25,
        paddingLeft:     25,
        paddingRight:    25,
        fontSize:        22,
    },
    title2: {
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      paddingLeft:     25,
      paddingRight:    25,
      fontSize:        22,
  },
  showFollowLink: {
    flex:            1,
    width:           '80%',
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    textAlign:       'center',
    paddingLeft:     25,
    paddingRight:    25,
    fontSize:        22,

  },
  subscriptionExpired: {
    fontSize:   21,
    marginLeft: 25,
    display:    'flex',
  },
  showUserInfo: {
    fontSize:   16,
    marginLeft: 25,
    display:    'flex',
  },
  bold: {
    fontWeight: 'bold',
    paddingRight: 10,
  },
  link: {
    textDecoration: 'none',
    maxWidth:       '100%',
    textAlign:      'center',
    wordBreak:      'break-all',
    fontSize:       17,
  }
}))

type TitlesType = {
    componentsState: componentsStateType;
    userInfo:        userInfoType;
    modalState:      modalStateType;
}

const Titles: React.FC<TitlesType> = ({
    componentsState,
    userInfo,
    modalState,
}) => {

  const { classes } = useStyles();

  const title          = useModalTitle();
  const expirationText = useExpirationText();

  const titleStyle = useMemo(() => {
    return {
      flex: modalState.modalVariant === 'showFollowLink' ? undefined : 1
    }
  },[modalState])

  return (
      <>
            {
              !!title.length &&
              <div 
                className = { classes.title }
                style     = { titleStyle } 
              >
                { title }
              </div>
            }
            {
               (modalState.modalVariant === 'getPlus' || (userInfo.userRole === 'student' && modalState.modalVariant === 'contact us'))
               &&
               <div className = { classes.title2 }>
                 { `${ words['getPlus2'][componentsState.lang] }` }
               </div>
            }
            {
              modalState.modalVariant === 'showFollowLink' &&
              <div className = { classes.showFollowLink }>
                 <a
                   className = { classes.link }
                   href      = { componentsState.followLink }
                  // target    = 'blank'
                 >
                   { `${ componentsState.followLink }` }
                 </a>
               </div>
            }
            {
                modalState.modalVariant === 'subscriptionExpired'//////
                &&
                <>
                {
                  expirationText.map((val, ind) => {
                     return(
                       <div
                          key       = { `${ val }==${ ind }` }
                          className = { classes.subscriptionExpired }
                       >
                         { val }
                       </div>
                     )
                  })
                }
                </>
            }
            {
              modalState.modalVariant === 'showUserInfo' &&
              <div style = {{ marginBottom: 25 }} >
              {
                Object.keys(userInfo).map((val, ind) => {

                   const value = val as userInfoKeyType;

                   return(
                      <div
                          key       = { `${ value }=#$%^=${ ind }` }
                          className = { classes.showUserInfo }
                          dir       = 'ltr'
                      >
                        <div className = { classes.bold }>{ `${ value } : ` }</div>
                        <div>{ `${ userInfo[`${ value }`] }` }</div>
                      </div>
                   )
                })
              }
              </div>
            }
     </>
  );
}



const mapStateToProps = (reducer: reducerType) => {

  return {
     componentsState: reducer.components,
     userInfo:        reducer.data.userInfo,
     modalState:      reducer.modal
}};


export default connect(mapStateToProps)(Titles);
